import React from 'react';
import styled, { css } from 'styled-components';

function GifRenderer({
  gifId,
  altText,
  onImageClicked,
  style,
}: {
  altText?: string;
  gifId: string;
  onImageClicked?: (url: string) => void;
  style?: React.CSSProperties;
}) {
  const gifUrl = `https://media0.giphy.com/media/${gifId}/giphy.gif`;
  return (
    <ImgStyled
      style={style}
      src={gifUrl}
      alt={altText}
      $objectFit="contain"
      onClick={() => onImageClicked && onImageClicked(gifUrl)}
      $clickable={!!onImageClicked}
    />
  );
}

const ImgStyled = styled.img<{ $objectFit?: string; $clickable?: boolean }>`
  width: 100%;
  height: 100%;

  ${({ $clickable }) =>
    $clickable &&
    css`
      cursor: pointer;
    `}
  ${({ $objectFit = 'contain' }) =>
    $objectFit &&
    css`
      object-fit: ${$objectFit};
    `}
`;

export default GifRenderer;
